import React, { FC } from "react";
import { Descriptions } from "antd";
import moment from "moment";

import "./whiteListInfo.scss";

interface Props {
  key: string;
  projectId: string;
  projectName: string;
  whiteListDate: string;
}

export const WhiteListTable: FC<Props> = ({
  projectId,
  projectName,
  whiteListDate,
}) => {
  return (
    <>
      <div className="table-size">
        <Descriptions
          bordered
          column={{ xxl: 3, xl: 3, lg: 3, md: 3, sm: 3, xs: 3 }}
        >
          <Descriptions.Item className="white-list-size" label="Project ID">
            {projectId}
          </Descriptions.Item>
          <Descriptions.Item className="white-list-size" label="Project Name">
            {projectName}
          </Descriptions.Item>
          <Descriptions.Item
            className="white-list-size"
            label="Whitelist created"
          >
            {moment(whiteListDate).format("YYYY/MM/DD HH:mm")}
          </Descriptions.Item>
        </Descriptions>
      </div>
    </>
  );
};
